import React from 'react'
import { upgradesEnabled } from '../../../lib/featureFlags'
import { PlanPickerModal } from './PlanPickerModal'

type Props = {
  title: string
  blurb: string
  ctaLabel?: string
}

export function UpgradePrompt({ title, blurb, ctaLabel = 'Upgrade plan' }: Props) {
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <div style={{
        border: '1px solid var(--border)',
        borderRadius: 10,
        padding: '16px 20px',
        background: 'var(--surface2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        flexWrap: 'wrap',
      }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>{title}</div>
          <div style={{ fontSize: 13, color: 'var(--text2)' }}>{blurb}</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flexShrink: 0 }}>
          <button
            className="btn-primary"
            onClick={() => upgradesEnabled && setOpen(true)}
            disabled={!upgradesEnabled || open}
            title={upgradesEnabled ? undefined : 'Upgrades not available yet'}
            style={{ whiteSpace: 'nowrap', cursor: upgradesEnabled ? 'pointer' : 'not-allowed' }}
          >
            {ctaLabel}
          </button>
          {!upgradesEnabled && (
            <span style={{ fontSize: 11, color: 'var(--text2)' }}>Coming soon</span>
          )}
        </div>
      </div>
      {upgradesEnabled && open && <PlanPickerModal onClose={() => setOpen(false)} />}
    </>
  )
}
